import React from "react";
import Grid from "@mui/material/Grid2";
import { Box } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import OptionButton from "../optionButton/optionButton";
import { AppContext } from "../../../../store/genesys.context";
import RenderSendMessageButton from "../renderSendMessageButton/renderSendMessageButton";
import RenderFilesForUpload from "../renderFilesForUpload/renderFilesForUpload";
import RenderChatInput, {
  CHAT_ATTACHMENTS_STATUS_ID,
  CHAT_INPUT_HINT_ID,
  CHAT_INPUT_STATUS_ID,
} from "../renderChatInput/renderChatInput";
import IMessage from "../../../../interface/IMessage";

const MessageInput = (): React.JSX.Element => {
  const {
    handleSubmitMessage,
    chatInput,
  }: {
    handleSubmitMessage: (e: { preventDefault: () => void }) => Promise<void>;
    chatInput: IMessage;
  } = React.useContext(AppContext);

  const attachmentStatus = chatInput?.content
    ? `Ausgewählte Datei: ${"name" in chatInput.content ? chatInput.content.name : chatInput.content.filename}`
    : "Keine Datei ausgewählt.";

  return (
    <form onSubmit={handleSubmitMessage} aria-label="Nachrichteneingabe">{/* A11Y FIX */}
      <Box component="span" id={CHAT_INPUT_HINT_ID} sx={visuallyHidden}>{/* A11Y FIX */}
        Drücke Enter zum Senden und Umschalt plus Enter für einen Zeilenumbruch.
      </Box>
      <Box
        component="span"
        id={CHAT_INPUT_STATUS_ID}
        sx={visuallyHidden}
        aria-live="polite"
        role="status"
      >{/* A11Y FIX */}
        {chatInput?.sending ? "Nachricht wird gesendet." : "Nachricht kann gesendet werden."}
      </Box>
      <Box
        component="span"
        id={CHAT_ATTACHMENTS_STATUS_ID}
        sx={visuallyHidden}
        aria-live="polite"
        role="status"
      >{/* A11Y FIX */}
        {attachmentStatus}
      </Box>
      <Grid container spacing={0}>
        <Grid size={{ xs: 12 }}>
          <RenderFilesForUpload />
        </Grid>
        <Grid size={{ xs: 9 }}>
          <RenderChatInput />
        </Grid>

        <Grid
          size={{ xs: 3 }}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "2px",
            pr: 1,
          }}
        >
          <OptionButton />
          <RenderSendMessageButton />
        </Grid>
      </Grid>
    </form>
  );
};

export default MessageInput;
